import "../Styles/Service.css"; // Import the CSS file
import LazyLoad from "react-lazyload";
import tax_car from "../images/tax_car.jpeg";
import { AppContext } from "../Context/Provider";
import ServiceItem from "./ServiceItems";
import { RiWallet3Fill } from "react-icons/ri";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdPricetag } from "react-icons/io";
const services = [
  {
    icon: <IoMdPricetag size={32} color="#4CAF4F" />,
    title: "Instant Bookings",
    description:
      "With our user-friendly app, you can book a taxi in seconds. Whether you're commuting to work or exploring the city, our service ensures a hassle-free experience.",
  },
  {
    icon: <RiWallet3Fill size={28} color="#4CAF4F" />,
    title: "Reliable Drivers",
    description:
      "Our network of professional drivers is dedicated to delivering safe, timely, and courteous service, ensuring you reach your destination comfortably.",
  },
  {
    icon: <IoSettingsOutline size={24} color="#4CAF4F" />,
    title: "Real-Time Tracking",
    description:
      "Stay informed with our GPS tracking feature, allowing you to monitor your ride's progress and estimated arrival time.",
  },
  {
    icon: <IoSettingsOutline size={24} color="#4CAF4F" />,
    title: "Flexible Payment Options",
    description:
      "Choose from multiple payment methods, including cash, credit/debit cards, and digital wallets, for a smooth transaction process.",
  },
];

const ServiceDriver = () => {
  // const { FetchHomeLearnMore, HomeLearnMoreData } = useContext(AppContext);

  // useEffect(() => {
  //   FetchHomeLearnMore();
  // }, []);

  return (
    <section className="py-10 learn-about-us-section">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-6">
        <div className="md:w-1/2 flex justify-center items-center">
          <LazyLoad height={180} offset={100} once key={tax_car}>
            <img src={tax_car} alt="Dhaweeye App Screenshot" width="500" />
          </LazyLoad>
        </div>
        <div className="md:w-1/2 flex flex-col justify-center h-full mt-20">
          {services.map((service, index) => (
            <ServiceItem
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceDriver;
